/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Aquí encontrarás a todos los actores de tu organización`
};

const en_persons_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Here you'll find all the members of your organization`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_subtitle", locale)
	if (locale === "es") return es_persons_subtitle(inputs)
	return en_persons_subtitle(inputs)
};
export { persons_subtitle as "persons.subtitle" }